module.exports = __webpack_public_path__ + "static/brener_og_banner_image-21ad9eb3499ab090d3ddb144b4bc28f6.jpg";